import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: Colors.adviceBackground,
    borderRadius: 3,
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingVertical: 20,

    paddingHorizontal: 20,
  },
});
